import { T } from "../themes";
import { PERSONAS, PERSONA_PREVIEW } from "../constants";
import { Lock } from "@phosphor-icons/react";

// V24 FIX 8c: isPremium gates Motivational and Critical.
// Free users see lock icon + PRO badge. Tapping a locked persona fires onLocked().
export default function PersonaPicker({ value, onChange, isPremium, onLocked }) {
  return (
    <div style={{display:"flex",flexDirection:"column",gap:8}}>
      {PERSONAS.map(({id,emoji})=>{
        const preview = PERSONA_PREVIEW[id];
        const locked = !isPremium && id !== "Balanced";
        return (
          <button key={id} onClick={()=>{
            if (locked) { onLocked?.(id); return; }
            onChange(id);
          }} style={{
            display:"flex",alignItems:"center",gap:10,padding:"10px 12px",
            background:value===id ? preview.accent : T.card,
            border:value===id ? `3px solid ${preview.accentDark||preview.accent}` : T.border,
            boxShadow:value===id ? T.shadow : T.shadowXs,
            color:value===id ? "#ffffff" : T.ink, cursor:"pointer",
            opacity:locked ? 0.7 : 1,
            transform:value===id?"translate(-2px,-2px)":"none",transition:"all 0.1s",
            width:"100%",textAlign:"left",borderRadius:T.radiusSm,
          }}>
            <span style={{fontSize:20,flexShrink:0}}>{emoji}</span>
            <div style={{flex:1}}>
              <p style={{margin:0,fontSize:11,fontWeight:700,fontFamily:T.fontSans,
                color:value===id ? "#ffffff" : T.ink}}>
                {preview.label}
              </p>
              <p style={{margin:0,fontSize:9,fontFamily:T.fontSans,fontWeight:"bold",
                color:value===id ? "rgba(255,255,255,0.8)" : T.textDim}}>
                {preview.sub}
              </p>
            </div>
            {locked ? (
              <span style={{display:"flex",alignItems:"center",gap:4,fontSize:9,fontFamily:T.fontSans,fontWeight:900,
                background:"rgba(0,0,0,0.3)",color:"#ffffff",padding:"3px 8px",
                letterSpacing:"0.5px",flexShrink:0,borderRadius:T.radiusXs}}>
                <Lock size={9}/> PRO
              </span>
            ) : value===id ? (
              <span style={{fontSize:10,fontFamily:T.fontSans,fontWeight:900,
                background:preview.accentDark||preview.accent,color:"#ffffff",padding:"2px 6px",
                letterSpacing:"0.5px",flexShrink:0,borderRadius:T.radiusXs}}>
                ACTIVE
              </span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
}
